import { ICellEditor, ICellEditorParams } from "ag-grid-community";
import { CustomCellEditorProps } from "ag-grid-react";
import { ZNumberInput } from "components/ZNumberInput";
import { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react";

const og = memo(({ value, onValueChange}: CustomCellEditorProps ) => {
    const updateValue = (val: string) => {
        onValueChange(val === "" ? null : parseInt(val));
      };
    return (

         <input
             type="text"
             value={value || ''}
             onChange={(event: any) => updateValue(event.target.value)}
         />
    );
 })

 const oldVersionAgGrideCode = forwardRef<ICellEditor, ICellEditorParams>((props, ref) => {
    const [value, setValue] = useState(props.value == null? undefined: props.value);
    useImperativeHandle(ref, () => ({
        getValue: () => value,
      }));
      return (
          <ZNumberInput
              autoFocus={true}
              type="aggrid-price"
              value={value}
              onChange={(e) => setValue(e)}
              containerClassName="h-100"
          />
      );
 });

export default  oldVersionAgGrideCode;
